/* eslint-disable */


/**
 * Create styles for `<LayoutTemplate2Page />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<LayoutTemplate2Page />` styles
 */
const layoutPageStyles = ({ theme }) => ({
  // implement as needed
});

export default layoutPageStyles;
